import { CfColors, CfPropTypeDictionary, Colors } from "types/generic/types";

const CF_COLOR_DICTIONARY: CfPropTypeDictionary<CfColors, Colors> = {
  white: "white",
  black: "black",
  accent: "accent",
  primary: "primary",
  secondary: "secondary",
  neutralPrimary: "neutralPrimary",
  neutralSecondary: "neutralSecondary",
  neutralTertiary: "neutralTertiary",
  neutralQuaternary: "neutralQuaternary",
  brandPrimary: "brandPrimary",
  brandSecondary: "brandSecondary",
  success: "success",
  warning: "warning",
  error: "error",
};

export const convertCfColorProps = (
  cfProp: CfColors | undefined | null,
): Colors => {
  if (!cfProp) return "";

  return CF_COLOR_DICTIONARY[cfProp] as Colors;
};
